import { gql } from '@apollo/client';

export const UPSERT_DEVOULUTION_PAGE_CONFIGS = gql`
  mutation UpsertDevolutionPageConfigs($configs: DevolutionPageConfigsInput!) {
    upsertDevolutionPageConfigs(configs: $configs) {
      __typename
      ... on UpsertDevolutionPageConfigsSuccess {
        code
        message
      }
      ... on Error {
        code
        message
      }
    }
  }
`;
